//SERVICES
import ServiceGift from "../../services/Gift";

//TYPES
export const START_LISTGIFT = "START_LISTGIFT";
export const IS_LISTGIFT = "  IS_LISTGIFT";
export const IS_LISTGIFT_NUMGIFT = "  IS_LISTGIFT_NUMGIFT";
export const ERROR_LISTGIFT = "  ERROR_LISTGIFT";
export const START_LISTFAMILY = "START_LISTFAMILY";
export const IS_LISTFAMILY = "  IS_LISTFAMILY";
export const ERROR_LISTFAMILY = "  ERROR_LISTFAMILY";

//const gift = useSelector(state => state.gift);

export function getListGiftAction(filter, from, to, order) {
  return async dispatch => {
    dispatch({ type: START_LISTGIFT });

    return new Promise((resolve, reject) => {
      ServiceGift.INSTANCE.getListGift(filter, from, to, order)
        .then(result => {
          dispatch({
            type: IS_LISTGIFT,
            payload: result.listGift
          });
          dispatch({
            type: IS_LISTGIFT_NUMGIFT,
            payload: result.numOfGift
          });
          resolve();
        })
        .catch(error => {
          dispatch({ type: ERROR_LISTGIFT });
          reject(error);
        });
    });
  };
}